import { takeEvery, put } from "redux-saga/effects";
import { request } from "../../../api/Service";
import { getErrorMessage } from "../../../components/utils/errorHandler";
import { toast } from "react-toastify";
export default function* watcherDeleteProductPrice() {
  yield takeEvery("DELETE_PRODUCT_SALES_PRICE", workerSaga);
}

function* workerSaga(action) {
  try {
    yield put({ type: "DISPLAY_LOADER" });
    let payload = {};
    var url = `/delete-product-sale-price/${action.payload}`;
    yield request("delete", action.payload, url).then((response) => {
      payload = response;
    });
    toast.success(payload);

    let formatUrl = "get-all-product-sale-price";
    yield request("get", action.payload, formatUrl).then((response) => {
      payload = response;
    });
    yield put({ type: "PRODUCT_SALESPRICE_LIST", payload: payload });

    yield put({ type: "DISPLAY_LOADER" });
  } catch (e) {
    yield put({ type: "LOADING_BUTTON_SPINNER" });
    yield put({ type: "DISPLAY_LOADER" });
    const errorMessage = getErrorMessage(e.response);
    toast.error(errorMessage);
    yield put({ type: "API_ERRORED", payload: e });
  }
}
